var map = {
	"./bg.jpg": "dZ/S",
	"./cage.png": "cxgI",
	"./che.png": "R14B",
	"./che2.png": "9Qey",
	"./code.png": "EF7e",
	"./eco.png": "EMyR",
	"./ewm.png": "bYLY",
	"./k11.jpg": "SszP",
	"./logo.png": "7Otq",
	"./logo1.png": "TrFT",
	"./logo2.png": "xAza",
	"./logo3.png": "mCmD",
	"./logo4.png": "zrjs",
	"./logo5.png": "Ux05",
	"./logo6.png": "UN16",
	"./logo7.png": "yAs+",
	"./logo8.png": "Q8hk",
	"./medica.png": "XoeB",
	"./part2.png": "IWxZ",
	"./pic1.png": "0Oa+",
	"./pic2.png": "34Bi",
	"./pic3.png": "KZxS",
	"./pic4.png": "l0S9",
	"./qiyeweixin1.jpeg": "3fPf",
	"./qiyeweixin14.jpeg": "H1yE",
	"./taikoo.png": "qVt1"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PvXa";


//////////////////
// WEBPACK FOOTER
// ./src/assets ^\.\/.*$
// module id = PvXa
// module chunks = 0